import { jsx as _jsx } from "react/jsx-runtime";
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { memoGeneric } from '@/js/libs/memo';
import { TabWrapper, Title } from './styled';
export const TabItem = memoGeneric(function TabItem({ item, active, onTabChange }) {
    const handleClick = useCallbackRef(() => {
        onTabChange(item.id);
    });
    const dataTestId = item.dataTestId || `${item.id}-tab`;
    if (item.hidden) {
        return null;
    }
    return (_jsx(TabWrapper, { "$active": active, onClick: handleClick, "data-testid": dataTestId, "data-active": active, children: _jsx(Title, { "$active": active, children: item.title }) }));
});
